import React, { useState, useEffect } from "react";
import { Alert as MuiAlert, Fade } from "@mui/material";
import style from "./Alert.module.css";

function Alert({ text, type = "success", duration = 3000, onClose }) {
  const [isVisible, setIsVisible] = useState(false);
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    setIsVisible(true);

    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => onClose && onClose(), 300);
    }, duration);

    const progressInterval = setInterval(() => {
      setProgress((prev) => Math.max(prev - 100 / (duration / 50), 0));
    }, 50);

    return () => {
      clearTimeout(timer);
      clearInterval(progressInterval);
    };
  }, [duration, onClose]);

  return (
    <Fade in={isVisible} timeout={300}>
      <div className={style.alertWrapper}>
        <MuiAlert severity={type}>
          <p className={style.alert}>{text}</p>
        </MuiAlert>
        <div className={style.progressBar} style={{ width: `${progress}%` }} />
      </div>
    </Fade>
  );
}

export default Alert;
